import { Injectable } from '@angular/core';
import { MessageService, ToastMessageOptions } from 'primeng/api';

import { AppConfig, appConfig } from '../../app.config';
import { environment } from '../../environments/environment';
import { AppEnvironment } from '../../environments/environment.model';

@Injectable({
    providedIn: 'root'
})
export class AppService {
    constructor(private messageService: MessageService) {}

    get appName(): string {
        return appConfig.name;
    }

    get appShort(): string {
        return appConfig.short_name ?? this.appName;
    }

    get config(): AppConfig {
        return appConfig;
    }

    get environment(): AppEnvironment {
        return environment;
    }

    toast(message: string, severity: 'success' | 'info' | 'warn' | 'error' = 'info', extra: Partial<ToastMessageOptions> = {}) {
        extra.life = extra.life ?? 5000;
        const summary: string = severity === 'warn' ? 'Warning' : severity.substring(0, 1).toUpperCase() + severity.substring(1);
        this.messageService.add({
            ...{
                severity,
                summary,
                detail: message
            },
            ...extra
        });
    }
}
